import axios from 'axios'
import { environment } from '@/data/environment/'

export default {
  namespaced: true,
  state: {
    statusGetMaxInvoiceAmountResponse: null,
    statusSetMaxInvoiceAmountResponse: null,
    maxInvoiceAmountConfigData: [],
    maxInvoiceAmountConfigMessage: '',
    listClients: [],
  },
  mutations: {
    setListClients (state, data) {
      state.listClients = data
    },
    setMaxInvoiceAmountConfigData (state, data) {
      state.maxInvoiceAmountConfigData = data
    },
    setResponseUpdateMaxInvoiceAmountConfig (state, data) {
      state.statusSetMaxInvoiceAmountResponse = data
    },
    setResponseGetMaxInvoiceAmountConfig (state, data) {
      state.statusGetMaxInvoiceAmountResponse = data
    },
    setResponseMaxInvoiceAmountConfigMsg (state, data) {
      state.maxInvoiceAmountConfigMessage = data
    },
  },
  actions: {
    getListClients ({ commit }) {
      const endpoint = '/api/getClients'
      const url = environment.HIOPOSWEBSERVICES + endpoint
      axios
        .create()
        .get(url)
        .then(response => {
          commit('setListClients', response.data)
        })
        .catch(function (error) {
          console.log(error.message)
        })
    },
    getMaxInvoiceAmountConfigData ({ commit }, data) {
      let params = 'IdCompania=' + -1
      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        params = 'IdCompania=' + JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      } else {
        params = 'IdCompania=' + data.IdCompania
      }

      const endpoint = '/api/getMaxInvoiceAmountConfigData?'
      const url = environment.HIOPOSWEBSERVICES + endpoint + params

      axios
        .create()
        .get(url)
        .then(response => {
            commit('setMaxInvoiceAmountConfigData', response.data.Data)
          if (response.data.Error) {
            commit('setResponseGetMaxInvoiceAmountConfig', true)
            commit('setResponseMaxInvoiceAmountConfigMsg', 'Hubo un error obteniendo la información de la configuración de Monto máximo permitido. Intentelo nuevamente.')
          } else {
            commit('setResponseGetMaxInvoiceAmountConfig', false)
            commit('setResponseMaxInvoiceAmountConfigMsg', 'Información de la configuración de Monto máximo permitido consultada exitosamente.')
          }
        })
        .catch(function (error) {
          commit('setResponseGetMaxInvoiceAmountConfig', true)
          commit('setResponseMaxInvoiceAmountConfigMsg', 'No pudo obtener información de la configuraicón de cambio de Monto máximo permitido. Intentelo nuevamente.')
          console.log(error.message)
        })
    },
    updateMaxInvoiceAmountConfigData ({ commit }, data) {
      const endpoint = '/api/updateMaxInvoiceAmountConfigData'
      const url = environment.HIOPOSWEBSERVICES + endpoint

      if (JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'Administrador' && JSON.parse(atob(localStorage.getItem('uid'))).rol !== 'AdminI+D' && JSON.parse(atob(localStorage.getItem('uid'))).rol.trim() !== 'Desarrollador') {
        data.IdCompania = JSON.parse(atob(localStorage.getItem('uid'))).idcompania
      }

      axios
        .create()
        .put(url, data)
        .then(response => {
          console.log(response)
            if (response.data.Error) {
              commit('setResponseUpdateMaxInvoiceAmountConfig', true)
              commit('setResponseMaxInvoiceAmountConfigMsg', 'Hubo un error guardando la información de Monto máximo permitido . Intentelo nuevamente.')
            } else {
              commit('setResponseUpdateMaxInvoiceAmountConfig', false)
              commit('setResponseMaxInvoiceAmountConfigMsg', 'Información de la configuración de Monto máximo permitido guardada exitosamente.')
            }
        })
        .catch(function (error) {
          commit('setResponseUpdateMaxInvoiceAmountConfig', true)
          commit('setResponseMaxInvoiceAmountConfigMsg', 'No pudo obtener información de la configuraicón de Monto máximo permitido')
          console.log(error.message)
        })
    },
    setUpdateStatusResponse ({ commit }, data) {
      commit('setResponseUpdateMaxInvoiceAmountConfig', data)
    },
    statusGetMaxInvoiceAmountResponse ({ commit }, data) {
      commit('setResponseGetMaxInvoiceAmountConfig', data)
    },
  },
}
